import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface ProfileNavigationProps {
  className?: string;
}

const ProfileNavigation: React.FC<ProfileNavigationProps> = ({ className = '' }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const profilePages = [
    {
      id: 'overview',
      title: 'Overview',
      path: '/profile',
      icon: 'fa-home',
      description: 'Complete profile overview'
    },
    {
      id: 'basic-info',
      title: 'Basic Info',
      path: '/profile/basic-info',
      icon: 'fa-user-graduate',
      description: 'Exam type & preparation level'
    },
    {
      id: 'subject-scores',
      title: 'Subject Scores',
      path: '/profile/subject-scores',
      icon: 'fa-chart-bar',
      description: 'Subject-wise performance'
    },
    {
      id: 'study-preferences',
      title: 'Study Preferences',
      path: '/profile/study-preferences',
      icon: 'fa-clock',
      description: 'Study patterns & preferences'
    },
    {
      id: 'sleep-schedule',
      title: 'Sleep Schedule',
      path: '/profile/sleep-schedule',
      icon: 'fa-bed',
      description: 'Sleep patterns & quality'
    },
    {
      id: 'commitments',
      title: 'Commitments',
      path: '/profile/commitments',
      icon: 'fa-calendar-alt',
      description: 'Time commitments & availability'
    },
    {
      id: 'account-settings',
      title: 'Account Settings',
      path: '/profile/account-settings',
      icon: 'fa-cog',
      description: 'Security & account management'
    }
  ];

  const currentPath = location.pathname;

  return (
    <div className={`profile-navigation ${className}`}>
      <div className="card border-0 shadow-sm" style={{ borderRadius: '20px' }}>
        <div className="card-body p-0">
          <div className="row g-0">
            {profilePages.map((page) => {
              const isActive = currentPath === page.path;
              return (
                <div key={page.id} className="col-6 col-md-4 col-lg-2">
                  <button
                    className={`btn w-100 h-100 d-flex flex-column align-items-center justify-content-center p-3 border-0 ${
                      isActive ? 'text-white' : 'text-muted'
                    }`}
                    style={{
                      background: isActive 
                        ? 'linear-gradient(135deg, #667eea, #764ba2)' 
                        : 'transparent',
                      borderRadius: isActive ? '20px' : '0',
                      minHeight: '100px',
                      transition: 'all 0.3s ease'
                    }}
                    onClick={() => navigate(page.path)}
                    onMouseEnter={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.backgroundColor = '#f8f9ff';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.backgroundColor = 'transparent';
                      }
                    }}
                  >
                    <i className={`fas ${page.icon} ${isActive ? 'fs-4' : 'fs-5'} mb-2`}></i>
                    <span className={`fw-bold ${isActive ? '' : 'small'}`} style={{ fontSize: isActive ? '0.9rem' : '0.8rem' }}>
                      {page.title}
                    </span>
                    {!isActive && (
                      <span className="text-muted" style={{ fontSize: '0.7rem', textAlign: 'center', lineHeight: '1.2' }}>
                        {page.description}
                      </span>
                    )}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      {/* <div className="card border-0 bg-light mt-3" style={{ borderRadius: '15px' }}>
        <div className="card-body p-3">
          <div className="row g-2 text-center">
            <div className="col-4">
              <button 
                className="btn btn-outline-primary btn-sm w-100"
                onClick={() => navigate('/study-plan')}
              >
                <i className="fas fa-route me-1"></i>
                Study Plan
              </button>
            </div>
            <div className="col-4">
              <button 
                className="btn btn-outline-success btn-sm w-100"
                onClick={() => navigate('/report-card')}
              >
                <i className="fas fa-chart-pie me-1"></i>
                Report Card
              </button>
            </div>
            <div className="col-4">
              <button 
                className="btn btn-outline-info btn-sm w-100"
                onClick={() => navigate('/performance')}
              >
                <i className="fas fa-trophy me-1"></i>
                Performance
              </button>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default ProfileNavigation;